import React from 'react';
import {Link} from 'react-router';
import { Collapse } from "@blueprintjs/core";
import classnames from 'classnames'
import moment from 'moment';

class LettersCount extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      isOpen: true,
      data: this.props.data,
      title: this.props.title
    }
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      title: nextProps.title
    })
  }

  render() {
    const { isDonViCha } = this.props;
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const getStyle = this.props.isTotal || !this.props.isDonViCon ? { width: '100%', paddingBottom: 0 } : {};
    const getLinkDonViCha = (value, type) => {
      let trangThaiDon = '';
      const quyenLanhDao = '&chiThuocQuyenLanhDao=true';
      if (type === 'DA_XU_LY') {
        trangThaiDon = '&trangThaiDon=DA_XU_LY&trangThaiDon=DA_GIAI_QUYET'
      }
      if (type === 'DANG_XU_LY') {
        trangThaiDon = '&trangThaiDon=DANG_XU_LY&trangThaiDon=DANG_GIAI_QUYET'
      }
      if (type === 'TRONGKY') {
        trangThaiDon = `&ky=${type}`
      }
      if (type === 'KYTRUOC') {
        trangThaiDon = `&ky=${type}`
      }
      if (this.props.link) {
        const currentYear = moment().year();
        localStorage.setItem('tdgstk.year', currentYear);
        return <Link to={`/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=${userInfo.donViId}${trangThaiDon}${quyenLanhDao}`} className='txt-underline'>{value}</Link>
      }
      return value;
    }
    return (
      <section
        style={getStyle}
        className="wrap-collapse pt30 col-6"
      >
        <div className="wrap-shadow">
          <h2 className={this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close"}>
            <Link onClick={this.handleCollapse.bind(this)}>
              { this.state.title }
            </Link>
          </h2>
          <Collapse className="row pl15 pr15 pb20" isOpen={this.state.isOpen}>
          {
            isDonViCha &&
              <div className="row d-flex">
                <div className="col-8">
                  <div
                    className={classnames('sum-default col-6 mb5', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })}
                  >
                    <p className="sum-title">Tiếp nhận trong kỳ</p>
                    <p className="sum-val">{this.state.data.trongKy ? getLinkDonViCha(this.state.data.trongKy, 'TRONGKY') : 0}</p>
                  </div>
                  <div
                    className={classnames('sum-default col-6 mb5', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })}
                  >
                    <p className="sum-title">Kỳ trước chuyển sang</p>
                    <p className="sum-val">{this.state.data.kyTruoc ? getLinkDonViCha(this.state.data.kyTruoc, 'KYTRUOC') : 0}</p>
                  </div>
                  <div
                    className={classnames('sum-default col-6', {
                      'total-letter': this.props.isTotal,
                        'sum-letter': !this.props.isTotal
                    })}
                  >
                    <p className="sum-title">Đơn đang XLĐ, GQĐ</p>
                    <p className="sum-val">
                      {this.state.data.donDangXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDangXuLyGiaiQuyet, 'DANG_XU_LY') : 0 }
                    </p>
                  </div>
                  <div
                    className={classnames('sum-default col-6', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })}
                  >
                    <p className="sum-title">Đơn đã XLĐ, GQĐ</p>
                    <p className="sum-val">
                      {this.state.data.donDaXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDaXuLyGiaiQuyet, 'DA_XU_LY') : 0 }
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <div
                    className={classnames('sum-default donvicha', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })}
                  >
                    <p className="sum-title">Tổng đơn </p>
                    <p className="sum-val">{this.state.data.tongSoDon ? getLinkDonViCha(this.state.data.tongSoDon) : 0}</p>
                  </div>
                </div>
              </div>
          }
          {
            !isDonViCha &&
            (
              <div>
                <div
                  className={classnames('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                      'sum-letter col-4': !this.props.isTotal
                  })}
                >
                  <p className="sum-title">Tổng đơn </p>
                  <p className="sum-val">{this.state.data.tongSoDon ? getLinkDonViCha(this.state.data.tongSoDon) : 0}</p>
                </div>
                <div
                  className={classnames('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                      'sum-letter col-4': !this.props.isTotal
                  })}
                >
                  <p className="sum-title">Đơn đang XLĐ, GQĐ</p>
                  <p className="sum-val">
                    {this.state.data.donDangXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDangXuLyGiaiQuyet, 'DANG_XU_LY') : 0 }
                  </p>
                </div>
                <div
                  className={classnames('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                    'sum-letter col-4': !this.props.isTotal
                  })}
                >
                  <p className="sum-title">Đơn đã XLĐ, GQĐ</p>
                  <p className="sum-val">
                    {this.state.data.donDaXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDaXuLyGiaiQuyet, 'DA_XU_LY') : 0 }
                  </p>
                </div>
                {
                  this.props.isTotal &&
                  <div
                    className={classnames('sum-default', {
                      'total-letter col-3': this.props.isTotal,
                      'sum-letter col-4': !this.props.isTotal
                    })}
                  >
                    <p className="sum-title">Đơn chuyển đơn vị ngoài</p>
                    <p className="sum-val">
                      { this.state.data.donChuyenDonViNgoai || 0 }
                    </p>
                  </div>
                }
              </div>
            )
          }
          </Collapse>
        </div>
      </section>
    );
  }
}

LettersCount.defaultProps = {
  title: '',
  data: []
}

export default LettersCount;


// WEBPACK FOOTER //
// ./src/components/modules/home/LettersCount.jsx